import { useEffect, CSSProperties, useState } from "react";

const getCssProperties = (footer?: any) => {
    const styles = {};

    if (footer?.bottomBackgroundColor) {
        styles["--footer-bottom-background-color"] = footer.bottomBackgroundColor;
    }
    if (footer?.bottomTextColor) {
        styles["--footer-bottom-text-color"] = footer.bottomTextColor;
    }

    // Anchor

    if (footer?.bottomAnchorColor) {
        styles["--footer-bottom-anchor-text-color"] = footer.bottomAnchorColor;
    }
    if (footer?.bottomHoverAnchorColor) {
        styles["--footer-bottom-anchor-hover-text-color"] = footer.bottomHoverAnchorColor;
    }

    return styles;
};

export default (footer: any): any => {
    const [result, setResult] = useState<CSSProperties>(getCssProperties(footer));

    useEffect(() => {
        setResult(getCssProperties(footer));
    }, [footer]);

    return result;
};
